import {
  extensionEventLabels,
  extensionEventTypes,
  hasBindingForEvent,
  ZExtensionEventType,
  ZExtensionFormBinding,
} from "../extensionBindings";

/**
 * События, к которым администратор привязывает расширение шага (макет MDM2-1070).
 * «При открытии» аналитик убрал из сценария 1.1: для шага пока только два события
 */
export const stepExtensionEvents: ZExtensionEventType[] = [
  "BEFORE_SAVE",
  "AFTER_SAVE",
];

export type StepEventOption = {
  event: ZExtensionEventType;
  label: string;
  disabled: boolean;
};

/**
 * Пункты меню «Добавить к событию».
 * К событию привязывается одно расширение, поэтому занятое событие неактивно
 */
export const getStepEventOptions = (
  bindings: ZExtensionFormBinding[],
): StepEventOption[] =>
  stepExtensionEvents.map((event) => ({
    event,
    label: extensionEventLabels[event],
    disabled: hasBindingForEvent(bindings, event),
  }));

/** Привязки в порядке событий, а не в порядке добавления */
export const sortStepBindings = (
  bindings: ZExtensionFormBinding[],
): ZExtensionFormBinding[] =>
  [...bindings].sort(
    (a, b) =>
      extensionEventTypes.indexOf(a.event) -
      extensionEventTypes.indexOf(b.event),
  );
